module.exports = __webpack_public_path__ + "img/mag (2).71aff300.png";